import React from 'react';
import PropTypes from 'prop-types';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import InformationIcon from '../../assets/icons/information-icon';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
export default function Confirm({
  open,
  setOpen,
  title,
  message,
  action,
  showCancel,
  cancelAction,
  messageAction,
  disableBackdropClose,
  hideCloseIcon,
  setVoidMessage,
  isVoidConfirmBox,
}) {
  function handleOpen() {
    setOpen(true);
  }

  const handleClose = () => {
    setOpen(false);
  };
  const handleBackdropClick = (event) => {
    if (disableBackdropClose) {
      event.stopPropagation();
    }
  };
  // console.log('showPriceChanged modal', message);
  return (
    <Modal
      open={open}
      onClose={handleClose}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      BackdropProps={{
        onClick: handleBackdropClick,
      }}
    >
      <Box
        sx={{
          backgroundColor: 'var(--paper-background-color)',
          border: 0,
          outline: 'none',
          borderRadius: '6px',
          margin: '0 100px 0 100px',
          width: '480px',
          minHeight: '300px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          textAlign: 'center',
          padding: '0 20px 0 20px',
          position: 'relative',
        }}
      >
        {!hideCloseIcon ? (
          <IconButton
            sx={{
              position: 'absolute',
              top: '10px',
              right: '10px',
            }}
            onClick={(e) => {
              e.preventDefault();
              handleClose();
            }}
          >
            <Close />
          </IconButton>
        ) : null}

        <Stack alignItems='center' spacing={4}>
          <Stack spacing={2} alignItems='center'>
            <InformationIcon />
            <Typography
              variant='h1'
              sx={{
                fontWeight: 500,
                marginTop: '22px',
                marginBottom: '6px',
              }}
            >
              {title}
            </Typography>
            <Typography variant='body2'>{message}</Typography>
            {messageAction}
          </Stack>

          {isVoidConfirmBox ? (
            <Stack alignItems='center' spacing={4}>
              <TextField
                required
                id='outlined-multiline-static'
                label='Add Message'
                onChange={(e) => {
                  e.preventDefault();
                  setVoidMessage(e.target.value);
                }}
                multiline
              />
            </Stack>
          ) : null}

          <Stack direction='row' spacing={2} justifyContent='center'>
            {showCancel ? (
              <Button
                variant='outlined'
                color='secondary'
                onClick={(e) => {
                  e.preventDefault();
                  handleClose();
                }}
              >
                No, Cancel
              </Button>
            ) : null}

            {action}
            {cancelAction}
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}

Confirm.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  action: PropTypes.node.isRequired,
  showCancel: PropTypes.bool,
  cancelAction: PropTypes.node,
  messageAction: PropTypes.node,
  disableBackdropClose: PropTypes.bool,
  hideCloseIcon: PropTypes.bool,
  isVoidConfirmBox: PropTypes.bool,
  setVoidMessage: PropTypes.func,
};
Confirm.defaultProps = {
  showCancel: true,
  cancelAction: null,
  messageAction: null,
  disableBackdropClose: false,
  hideCloseIcon: false,
};
